import { FC } from 'react';
import { Button, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  shallow?: boolean;
}

const baseStyles = createStyles({
  base: {
    borderRadius: '3px',
    fontWeight: 'bold',
    letterSpacing: 0,
    opacity: 1,
  },
});

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    primary: (props: StyleProps) => ({
      ...baseStyles.base,
      backgroundColor: '#FFCF18',
      color: '#142E38',
      boxShadow: props.shallow
        ? '0px 2px 4px #00000029'
        : '0px 2px 10px #00000029',
      fontSize: props.shallow ? '14px' : '16px',
      lineHeight: props.shallow ? '21px' : '24px',
      overflow: 'hidden',
      position: 'relative',
      '&:hover': { backgroundColor: '#FFC900' },
      '&:focus': { backgroundColor: '#FFD740' },
      '&:active': { backgroundColor: '#FFD740' },
      '&.Mui-disabled': {
        color: '#333333',
        backgroundColor: '#FFCF18',
        opacity: 0.5,
      },
      '& > span:first-child': {
        zIndex: 1,
      },
      '& .MuiTouchRipple-root': {
        color: '#FFEF5F',
      },
    }),
    secondary: {
      ...baseStyles.base,
      backgroundColor: '#FFFFFF',
      color: '#256ADB',
      border: '1px solid #256ADB',
      fontSize: '16px',
      lineHeight: '21px',
      '&:hover': { backgroundColor: '#EBF3FE' },
      '&:active': { backgroundColor: '#C6DAFC' },
      '&:focus': { backgroundColor: '#FFFFFF' },
      '&.Mui-disabled': {
        color: '#256ADB',
        opacity: 0.5,
      },
    },
  }),
);

export interface StyledButtonProps extends StyleProps {
  variant?: string;
  label?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const StyledButton: FC<StyledButtonProps> = ({
  variant,
  label,
  shallow,
  className,
  disabled = false,
  ...props
}) => {
  const classes = useStyles({ shallow: shallow });

  return (
    <Button
      className={`${classes[variant ?? 'primary']} ${className}`}
      disabled={disabled}
      {...props}
    >
      {label}
    </Button>
  );
};
